<div class="ups-dialog">
    <div class="dialog-header">
        <h2 mat-dialog-title>{{'internationalProductDisclosure.title'|translate}}</h2>
        <mat-dialog-actions>
        </mat-dialog-actions>
        <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="main-div" *ngIf="isDEUser" >
        <p>
            {{ 'internationalProductDisclosure.1'|translate }}
        </p>
        <p>
            {{ 'internationalProductDisclosure.2'|translate }}
        </p>
        <p>
            {{ 'internationalProductDisclosure.3'|translate }} <br>
            {{ 'internationalProductDisclosure.4'|translate }} <br>
            {{ 'internationalProductDisclosure.5'|translate }} <br>
            {{ 'internationalProductDisclosure.6'|translate }} 
        </p>
        <p>
            {{ 'internationalProductDisclosure.7'|translate }}
        </p>
    </div>
    <div class="main-div" *ngIf="isGBUser" [innerHtml]="'internationalProductDisclosure.contentUK'|translate" >

    </div>
</div>